import { createAsyncThunk } from "@reduxjs/toolkit";
import api, { ErrorType } from ".";
import { toast } from "react-toastify";

type DepositType = {
  customer_reference: string;
  merchant_reference: string;
  payment_type: string;
};

export type DepositResponse = {
  key: string;
  url: string;
  origin: string;
};

type WithdrawType = {
  amount: string;
  customer_name: string;
};

export type WithdrawResponse = {
  key: string;
  url: string;
};

type CryptoDepositType = {
  orderName: string;
  currency: string;
  amount: string;
};

export type CryptoDepositResponse = {
  status: string;
  data: any;
};

export const routes = {
  deposit: "/api/payment/deposit",
  withdtaw: "/api/payment/withdraw",
  cryptoDeposit: "/api/payment/crypto/deposit",
};

export const deposit = createAsyncThunk<
  DepositResponse,
  DepositType,
  {
    rejectValue: ErrorType;
  }
>("/payment/deposit", async (data, { rejectWithValue }) => {
  try {
    const response = await api.post(`${routes.deposit}`, data);
    return response.data;
  } catch (e: any) {
    return rejectWithValue({
      message: e.message,
    } as ErrorType);
  }
});

export const withdraw = createAsyncThunk<
  WithdrawResponse,
  WithdrawType,
  {
    rejectValue: ErrorType;
  }
>("/payment/withdraw", async (data, { rejectWithValue }) => {
  try {
    const response = await api.post(`${routes.withdtaw}`, data);
    return response.data;
  } catch (e: any) {
    return rejectWithValue({
      message: e.message,
    } as ErrorType);
  }
});

export const cryptoDeposit = createAsyncThunk<
  CryptoDepositResponse,
  CryptoDepositType,
  {
    rejectValue: ErrorType;
  }
>("/payment/crypto/deposit", async (data, { rejectWithValue }) => {
  try {
    const response = await api.post(`${routes.cryptoDeposit}`, data);
    return response.data;
  } catch (e: any) {
    return rejectWithValue({
      message: e.message,
    } as ErrorType);
  }
});
